import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const updateSection = createAsyncThunk(
	"updateSection",
	async ({ id, data, onSuccess }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.patch(`section/update?id=${id}`, data);
			message.success("Section successfully updated!");
			if (onSuccess) {
				onSuccess();
			}
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			message.error(err.response.data.message || "Failed to update section");
			return rejectWithValue(err.response.data);
		}
	}
);

const sectionUpdateSlice = createSlice({
	name: "sectionUpdate",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(updateSection.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(updateSection.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateSection.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default sectionUpdateSlice.reducer;
